import { isTestEnv } from "@smart/itops-utils-basic";

import { defaultEnv, EnvKey } from "./types";
import { uxEnv, UxKey } from "./ux";
import { values } from "./variables.config";

let forcedEnv: Partial<Record<EnvKey, string>> | undefined;

export const forceEnv = (env: Partial<Record<EnvKey, string>> | undefined) => {
  if (!isTestEnv()) throw new Error("forceEnv only available in test");

  forcedEnv = env;
};

export const loadEnv = (key: EnvKey) => {
  if (isLocalServer) return forcedEnv?.[key] ?? defaultEnv[key];
  if (isUXMode) return uxEnv[isUXMode as UxKey][key];

  return values[key];
};
